import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Styles } from '@contently/toolkit';

/** Base URL of images used by the Integration code (these are under /public in the git repo) */
const INTEGRATION_ICON_BASE = "/images/integrations";

/** The overall styling of the Integration card */
const CardWrapper = styled.a`
  color: inherit;
  text-decoration: inherit;
  font-weight: inherit;
  display-style: inline-block;
  border: solid 1px ${Styles.colors.grey.secondaryDark};
  border-radius: 2px;
  width: 300px;
  padding: 19px;
  margin-right: 20px;
  margin-bottom: 20px;
  &:link, &:visited, &:hover, &:active {
    color: inherit;
    text-decoration: inherit;
    font-weight: inherit;
  };
  &:hover {
    background-color ${Styles.colors.grey.secondaryLight}
  };
`;

/** Displayable name of the Integration */
const IntegrationName = styled.span`
  font-size: 1.25rem;
  font-weight: 500;
`;

/** Integration icon image */
const IntegrationIcon = styled.img`
  height: 56px;
  margin-bottom: 10px;
`;

/** Description of the Integration */
const IntegrationDescription = styled.div`
  font-size: 1rem;
  font-weight: 325;
`;

/**
 * Integration Card component
 * 
 * @param {object} props
 * @returns React.Component
 */
function IntegrationCard({available=true, platform, title, description, link}) {
  const icon = `${INTEGRATION_ICON_BASE}/${platform}.svg`;

  return ( available && 
    <CardWrapper href={link} id={`addIntegration:${platform}`}>
      <IntegrationIcon src={icon} /> <br />
      <IntegrationName>{title}</IntegrationName>
      <IntegrationDescription>{description}</IntegrationDescription>
    </CardWrapper>
  )
}

IntegrationCard.propTypes = {
  /** Whether or not this card is available for the current brandProfile */
  available: PropTypes.bool.isRequired,
  /** Internal integration platform name (see app/models/integration.rb) */
  platform: PropTypes.string.isRequired,
  /** User-readable name of this integration */
  title: PropTypes.string.isRequired,
  /** User-readable description of this integration */
  description: PropTypes.string.isRequired,
  /** Page to link to when the user clicks this card */
  link: PropTypes.string.isRequired,
};

export default IntegrationCard;


// WEBPACK FOOTER //
// ./app/javascript/app/components/integrations/IntegrationCard.jsx